import React from "react";
import Col from "react-bootstrap/Col";
import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import "./PulseSurveySectionDetails.css";

function PulseSurveySectionDetails({ sectionName, questions }) {
  const { t } = useTranslation();

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      y: {
        // Configuration for the y-axis (vertical)
        min: 0, // Set the minimum value of the scale
        max: 100, // Set the maximum value of the scale
        ticks: {
          // Include a specific step size for tick marks (optional)
          stepSize: 10,
        },
      },
      x: {
        // Configuration for the x-axis (horizontal)
        // You can add configurations for the x-axis here as well
      },
    },
  };

  return (
    <Col className="pulse-survey-section">
      <Col className="center">
        <h3 className="mb-3">{sectionName}</h3>
      </Col>
      <Col key={sectionName} className="pulse-survey-section-questions">
        {questions.map((question) => (
          <Col key={question.description} className="pulse-survey-question">
            <h6>{question.description}</h6>
            <Col>
              <Line data={question.chartData} options={options}></Line>
            </Col>
          </Col>
        ))}
      </Col>
    </Col>
  );
}

export default PulseSurveySectionDetails;
